/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface PostFeedbackRequest {
    selectedMood?: string;
    categorie?: string;
    summary?: string;
    description?: string;
    buildVersionInfo?: string;
}

/**
 * 
 */
export class FeedbackResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for postFeedback without sending the request
     */
    async postFeedbackRequestOpts(requestParameters: PostFeedbackRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['selectedMood'] != null) {
            queryParameters['selectedMood'] = requestParameters['selectedMood'];
        }

        if (requestParameters['categorie'] != null) {
            queryParameters['categorie'] = requestParameters['categorie'];
        }

        if (requestParameters['summary'] != null) {
            queryParameters['summary'] = requestParameters['summary'];
        }

        if (requestParameters['description'] != null) {
            queryParameters['description'] = requestParameters['description'];
        }

        if (requestParameters['buildVersionInfo'] != null) {
            queryParameters['buildVersionInfo'] = requestParameters['buildVersionInfo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/feedback/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async postFeedbackRaw(requestParameters: PostFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postFeedbackRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postFeedback(requestParameters: PostFeedbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postFeedbackRaw(requestParameters, initOverrides);
    }

}
